/**
 * Логотип «Облік+» (ч.1229, рішення власника: замість напису «Облікова система»).
 *
 * Два розміри: `header` — знак і назва (шапка застосунку), `full` — зі слоганом (сторінка
 * входу). Кожен — у двох варіантах: денний (темний напис) і нічний (світлий напис);
 * потрібний показує CSS за `data-theme` (Закон дизайну #11 — сторінка читається в обох
 * режимах). Файли зібрано з растрового оригіналу: прозоре тло замість білого.
 */
import fullDay from '@/assets/brand/logo-full.png';
import fullNight from '@/assets/brand/logo-full-night.png';
import headerDay from '@/assets/brand/logo-header.png';
import headerNight from '@/assets/brand/logo-header-night.png';

export const BRAND_NAME = 'Облік+';

export default function BrandLogo({ variant = 'header' }: { variant?: 'header' | 'full' }) {
  const [day, night] = variant === 'full' ? [fullDay, fullNight] : [headerDay, headerNight];
  return (
    <span className={`brand-logo brand-logo--${variant}`} role="img" aria-label={BRAND_NAME}>
      <img className="brand-logo__day" src={day} alt="" draggable={false} />
      <img className="brand-logo__night" src={night} alt="" draggable={false} />
    </span>
  );
}
